/**
 * Predictive Search — AJAX search with instant results
 * Shows only Products and FAQ pages.
 */
(function () {
  'use strict';

  var SEARCH_ENDPOINT = '/search/suggest.json';
  var DEBOUNCE_MS = 300;
  var MIN_CHARS = 2;

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function PredictiveSearch(input, resultsContainer) {
    this.input = input;
    this.results = resultsContainer;
    this.timer = null;
    this.abortController = null;
    this.isOpen = false;

    this.init();
  }

  PredictiveSearch.prototype.init = function () {
    var self = this;

    this.input.addEventListener('input', function () {
      clearTimeout(self.timer);
      var query = self.input.value.trim();

      if (query.length < MIN_CHARS) {
        self.close();
        return;
      }

      self.timer = setTimeout(function () {
        self.search(query);
      }, DEBOUNCE_MS);
    });

    this.input.addEventListener('focus', function () {
      if (self.input.value.trim().length >= MIN_CHARS && self.results.innerHTML.trim()) {
        self.open();
      }
    });

    document.addEventListener('click', function (e) {
      if (!self.input.contains(e.target) && !self.results.contains(e.target)) {
        self.close();
      }
    });

    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        self.close();
        self.input.blur();
      }
    });
  };

  PredictiveSearch.prototype.search = function (query) {
    var self = this;

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    var params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,page',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last'
    });

    fetch(SEARCH_ENDPOINT + '?' + params.toString(), {
      signal: this.abortController.signal
    })
      .then(function (res) { if (!res.ok) throw new Error('Search request failed'); return res.json(); })
      .then(function (data) {
        self.renderResults(data.resources.results, query);
        self.open();
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          console.error('Search error:', err);
        }
      });
  };

  PredictiveSearch.prototype.renderResults = function (results, query) {
    var html = '';
    var hasResults = false;

    // Products
    if (results.products && results.products.length) {
      hasResults = true;
      html += '<div class="predictive-search__group">';
      html += '<h4 class="predictive-search__group-title">Products</h4>';
      results.products.forEach(function (product) {
        var image = escapeHtml(product.image);
        var title = escapeHtml(product.title);
        var url = escapeHtml(product.url);
        var price = product.price ? '&#8377;' + parseFloat(product.price).toFixed(0) : '';
        html += '<a href="' + url + '" class="predictive-search__item">';
        if (image) {
          html += '<img class="predictive-search__item-image" src="' + image + '" alt="' + title + '" width="48" height="48" loading="lazy">';
        }
        html += '<div class="predictive-search__item-info">';
        html += '<span class="predictive-search__item-title">' + title + '</span>';
        if (price) html += '<span class="predictive-search__item-price">' + price + '</span>';
        html += '</div>';
        html += '</a>';
      });
      html += '</div>';
    }

    // Pages — only show FAQ-related pages
    if (results.pages && results.pages.length) {
      var faqPages = results.pages.filter(function (page) {
        var t = (page.title || '').toLowerCase();
        var u = (page.url || '').toLowerCase();
        return t.indexOf('faq') !== -1 || t.indexOf('frequently') !== -1 || u.indexOf('faq') !== -1;
      });

      if (faqPages.length) {
        hasResults = true;
        html += '<div class="predictive-search__group">';
        html += '<h4 class="predictive-search__group-title">Help</h4>';
        faqPages.forEach(function (page) {
          html += '<a href="' + escapeHtml(page.url) + '" class="predictive-search__item">';
          html += '<div class="predictive-search__item-info">';
          html += '<span class="predictive-search__item-title">' + escapeHtml(page.title) + '</span>';
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
      }
    }

    if (!hasResults) {
      html = '<div class="predictive-search__no-results">';
      html += '<p>No results found for &ldquo;' + escapeHtml(query) + '&rdquo;</p>';
      html += '</div>';
    }

    this.results.innerHTML = html;
  };

  PredictiveSearch.prototype.open = function () {
    this.results.classList.add('is-open');
    this.isOpen = true;
  };

  PredictiveSearch.prototype.close = function () {
    this.results.classList.remove('is-open');
    this.isOpen = false;
  };

  // Initialize
  document.addEventListener('DOMContentLoaded', function () {
    var inputs = document.querySelectorAll('[data-predictive-search-input]');
    inputs.forEach(function (input) {
      var wrapper = input.closest('[data-predictive-search]');
      if (!wrapper) return;
      var results = wrapper.querySelector('[data-predictive-search-results]');
      if (results) new PredictiveSearch(input, results);
    });
  });
})();
